// extracted by mini-css-extract-plugin
export default {"header-contents":"header_header-contents__UbTOh","header-images":"header_header-images__vGwHe","header-description":"header_header-description__Mrtnt"};